
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Cropper from 'react-cropper';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import EmptyState from 'Components/EmptyState/EmptyState';
import Button from 'Components/Button';
import CropIcon from 'Components/icons/CropIcon';
import BlackAndWhiteIcon from 'Components/icons/BlackAndWhiteIcon';
import ImageDeleteIcon from 'Components/icons/ImageDeleteIcon';
import ImageDuplicateIcon from 'Components/icons/ImageDuplicateIcon';
import ImageRedactIcon from 'Components/icons/ImageRedactIcon';
import ImageRotateIcon from 'Components/icons/ImageRotateIcon';
import ImageSharpenIcon from 'Components/icons/ImageSharpenIcon';
import PencilIcon from 'Components/icons/PencilIcon';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import SelectInput from 'Components/forms/select-input/SelectInput.jsx';
import ZoomOutIcon from 'Components/icons/ZoomOutIcon';
import ZoomInIcon from 'Components/icons/ZoomInIcon';
import PagesIcon from 'Components/icons/PagesIcon';
import PageSelector from 'Components/PageSelector';
import { filterImage } from 'Utils/imageUtil.js';
import { connect } from 'react-redux';
import { transformImage } from 'Actions/imageEditorAction';

import './ImageToolkit.scss';
import 'cropperjs/dist/cropper.css';
import LeftArrowIcon from '../icons/left-arrow-icon/LeftArrowIcon';
import RightArrowIcon from '../icons/right-arrow-icon/RightArrowIcon';
import * as KeyConstants from 'Utils/constants/keyConstants.js';
import counterpart from 'counterpart';
/*
const GROUP_BUTTONS = [
  {
    'title': 'Crop',
    'action': this.rotateToRight.bind(this),
    'icon': ImageDuplicateIcon,
  }
]
*/
const __ON_KEY_DOWN__ = 'keydown';
const __ON_KEY_PRESS__ = 'keypress';
const __UNDER_SCORE__ = "_";
export class ImageToolkit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rotateImage: [
        {
          rotateIndex: 0,
        },
      ],
      operationPerformed: [
        {
          flag: false,
        },
      ],
      canvasSelectedIndex: 0,
      pencilColor: '#0F7DC4',
      selectedZoom: { value: 100, text: '100%' },
      currentZoomValue: 0.0,
      zoomText: '100%',
      zoomValues: [
        {
          value: -0.5,
          text: '50%',
        },
        {
          value: -0.4,
          text: '60%',
        },
        {
          value: -0.3,
          text: '70%',
        },
        {
          value: -0.2,
          text: '80%',
        },
        {
          value: -0.1,
          text: '90%',
        },
        {
          value: 0.0,
          text: '100%',
        },
        {
          value: 0.1,
          text: '110%',
        },
        {
          value: 0.2,
          text: '120%',
        },
        {
          value: 0.3,
          text: '130%',
        },
        {
          value: 0.4,
          text: '140%',
        },
        {
          value: 0.5,
          text: '150%',
        },
        {
          value: 0.6,
          text: '160%',
        },
        {
          value: 0.7,
          text: '170%',
        },
        {
          value: 0.8,
          text: '180%',
        },
        {
          value: 0.9,
          text: '190%',
        },
        {
          value: 1.0,
          text: '200%',
        },

      ],
      pageList: [
        {
          pageContent: '',
          pageId: 0,
        },
      ],
      imageZoom: 0.1,
      dragMode: 'move',
      showPageSelector: false,
      toggleRedact: false,
      toggleCrop: false,
      showImageToolkit: false,
    };

    this.updatePageSelectionIndex = this.updatePageSelectionIndex.bind(this);
    this.onZoom = this.onZoom.bind(this);
    this.toggleCanvas = this.toggleCanvas.bind(this);
    this.addCropFloatingButton = this.addCropFloatingButton.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
  }

  componentWillMount() {
    let pageListClone = [];
    let rotateImageClone = [];
    let operationPerformedClone = [];
    if(['EMD', 'MXP'].includes(this.props.acquirerCode)){
      this.props.pageList.map((image) => {
        rotateImageClone = rotateImageClone.concat({ rotateIndex: 0 });
        operationPerformedClone = operationPerformedClone.concat({ flag: false });
        pageListClone = pageListClone.concat({ pageId: image.pageId, pageContent: image.pageContent, docId: image.docId, documentName : image.documentName, documentType:image.documentType });
      });
    }else{
      this.props.imageContents.map((image, imageIndex) => {
        rotateImageClone = rotateImageClone.concat({ rotateIndex: 0 });
        operationPerformedClone = operationPerformedClone.concat({ flag: false });
        pageListClone = pageListClone.concat({ pageId: imageIndex, pageContent: image });
      });
    }
    const pageListBackup = JSON.parse(JSON.stringify(pageListClone));
    this.setState({
      pageList: pageListClone,
      rotateImage: rotateImageClone,
      operationPerformed: operationPerformedClone,
      orignalImages: pageListBackup,
    });
    document.addEventListener(__ON_KEY_DOWN__, this.onKeyPress);
    document.addEventListener(__ON_KEY_PRESS__, this.onKeyPress);
  }
  componentDidMount() {
    const { canvas } = this.refs;
    const ctx = canvas.getContext('2d');
    const img = this.refs.image;

    img.onload = function () {
      draw(this);
    };

    function draw(img) {
      ctx.drawImage(img, 0, 0, img.width / 4, img.height / 4);
    }
  }
  componentWillUnmount() {
    document.removeEventListener(__ON_KEY_DOWN__, this.onKeyPress);
    document.removeEventListener(__ON_KEY_PRESS__, this.onKeyPress);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.imageContents.length !== this.props.imageContents.length) {
      let pageListClone = [];
      let rotateImageClone = [];
      let operationPerformedClone = [];

      nextProps.imageContents.forEach((image, imageIndex) => {
        rotateImageClone = rotateImageClone.concat({ rotateIndex: 0 });
        operationPerformedClone = operationPerformedClone.concat({ flag: false });
        pageListClone = pageListClone.concat({ pageId: imageIndex, pageContent: image });
      });

      const pageListBackup = JSON.parse(JSON.stringify(pageListClone));
      this.setState({
        imageZoom: 0.3,
        pageList: pageListClone,
        rotateImage: rotateImageClone,
        operationPerformed: operationPerformedClone,
        orignalImages: pageListBackup,
      });
    }

    if (this.props.updateFlag !== nextProps.updateFlag) {
      this.toggleCanvas(this.state.pageList);
    }

    if (nextProps.canvasSelectedIndex !== this.props.canvasSelectedIndex) {
      this.setState({
        zoomText: '100%',
        currentZoomValue: 0.0,
      })
    }
	
	if (this.props.zoomReset) {
      this.setState({
        zoomText: '100%',
        currentZoomValue: 0.0,
      })
    } 
  }

  _crop(event) {
    this.setState({
      cropped: this.refs.cropper.getCroppedCanvas().toDataURL(),
    });
  }
  onKeyPress(event) {
    const eventCode = event.code ? (event.code) : event.key;
    switch (eventCode) {
      case KeyConstants.RIGHTARROW:
      case KeyConstants.KEY_CODE_RIGHTARROW:
        this.props.updatePageSelectionIndex == undefined ? this.updatePageSelectionIndex(this.state.canvasSelectedIndex + 1) : this.props.updatePageSelectionIndex(this.props.canvasSelectedIndex + 1)
        event.preventDefault();
        break;
      case KeyConstants.LEFTARROW:
      case KeyConstants.KEY_CODE_LEFTARROW:
        this.props.updatePageSelectionIndex == undefined ? this.updatePageSelectionIndex(this.state.canvasSelectedIndex - 1) : this.props.updatePageSelectionIndex(this.props.canvasSelectedIndex - 1)
        event.preventDefault();
        break;

    }

  }

  imageTrasformation(imageOperation) {
    if (this.refs.cropper != undefined) {
      const imageWidth = this.refs.cropper.getImageData().naturalWidth;
      const imageHeight = this.refs.cropper.getImageData().naturalHeight;
      const img = new Image();
      img.src = this.state.pageList[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent;
      const data = filterImage(img, imageWidth, imageHeight, imageOperation);

      if (data && data !== this.state.pageList[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent) {
        const pageListClone = [...this.state.pageList];
        const operationPerformedClone = [...this.state.operationPerformed];
        if(imageOperation === 'grayscale'){
          pageListClone[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent = data;
        }
        operationPerformedClone[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].flag = true;
        if (this.props.updatePageList !== undefined) { this.props.updatePageList(pageListClone); }
        this.setState({
          pageList: pageListClone,
          operationPerformed: operationPerformedClone,
          zoomText: '100%',
          currentZoomValue: 0.0,
        });
      }
    }
  }

  sharpenTheImage() {
    this.imageTrasformation('sharpen');
  }

  handlePageSelector() {
    const pageSelector = !this.state.showPageSelector;
    this.setState({
      showPageSelector: pageSelector,
      showImageToolkit: pageSelector ? false : this.state.showImageToolkit,
    });
  }

  showImageToolKit() {
    const showImageToolkit = !this.state.showImageToolkit;
    this.setState({
      showImageToolkit,
      showPageSelector: showImageToolkit ? false : this.state.showPageSelector,
      pencilColor: showImageToolkit ? '#9A9FAC' : '#0F7DC4',
    });
  }

  duplicateImage() {
    const nextPageSize = this.state.pageList.length;
    const pageListClone = this.state.pageList.concat({
      pageContent: this.state.pageList[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent,
      pageId: nextPageSize,
    });
    if (this.props.updatePageList !== undefined) { this.props.updatePageList(pageListClone); }
    const pageListBackup = JSON.parse(JSON.stringify(pageListClone));
    this.setState({
      pageList: pageListClone,
      orignalImages: pageListBackup,
      operationPerformed: this.state.operationPerformed.concat({ flag: 0 }),
      rotateImage: this.state.rotateImage.concat({ rotateIndex: 0 }),
    });
  }


  deleteImage() {
    const tempPageList = this.state.pageList.filter((image) => {
      return image.pageId !== (this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex);
    });
    let pageId = 0;
    tempPageList.forEach(page => {
      page.pageId = pageId++;
    })
    if (this.props.updatePageList !== undefined) { this.props.updatePageList(tempPageList, 0); }
    this.setState({
      pageList: tempPageList,
      canvasSelectedIndex: 0,
    });
  }

  makeGrayScale() {
    this.imageTrasformation('grayscale');
  }

  getMaskedCanvas(sourceImage, cropper) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    const maskWidth = cropper.getData().width;
    const maskHeight = cropper.getData().height;
    const maskTop = cropper.getData().y;
    const maskLeft = cropper.getData().x;

    const imageWidth = cropper.getImageData().naturalWidth;
    const imageHeight = cropper.getImageData().naturalHeight;

    canvas.width = imageWidth;
    canvas.height = imageHeight;
    context.imageSmoothingEnabled = true;

    const image = new Image();
    image.src = sourceImage;

    context.drawImage(image, 0, 0, imageWidth, imageHeight);
    context.fillRect(maskLeft, maskTop, maskWidth, maskHeight);
    return canvas;
  }

  getFakeCanvas(sourceImage, cropper) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const imageWidth = cropper.getImageData().naturalWidth;
    const imageHeight = cropper.getImageData().naturalHeight;

    canvas.width = imageWidth - 1;
    canvas.height = imageHeight - 1;
    context.imageSmoothingEnabled = true;

    const image = new Image();
    image.src = sourceImage;
    context.drawImage(image, 0, 0, imageWidth, imageHeight);

    return canvas;
  }

  addCropFloatingButton(child, addbutton) {
    addbutton.className = 'crop-floating-button';
    addbutton.id = 'crop';
    addbutton.innerText = 'Crop';
    child.parentNode.insertBefore(addbutton, child.nextSibling);
    addbutton.onclick = this.buttonCrop.bind(this);
  }

  startCrop() {
    const node = ReactDOM.findDOMNode(this);
    if (node instanceof HTMLElement && !node.querySelector('.crop-floating-button')) {
      const child = node.querySelector('.point-se');
      const addbutton = document.createElement('button');
      this.addCropFloatingButton(child, addbutton);
    }

    if (!this.state.toggleRedact) {
      if (this.state.toggleCrop) {
        const pageListClone = [...this.state.pageList];
        pageListClone[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent = this.state.cropped;

        const operationPerformedClone = [...this.state.operationPerformed];
        operationPerformedClone[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].flag = true;
        if (this.props.updatePageList !== undefined) { this.props.updatePageList(pageListClone); }
        this.setState({
          pageList: pageListClone,
          operationPerformed: operationPerformedClone,
          dragMode: 'move',
          toggleCrop: !this.state.toggleCrop,
        });
      } else {
        this.setState({
          dragMode: 'crop',
          toggleCrop: !this.state.toggleCrop,
        });
      }
    }
  }

  buttonCrop() {
    if (!this.state.toggleRedact) {
      if (this.state.toggleCrop) {
        const pageListClone = [...this.state.pageList];
        pageListClone[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent = this.state.cropped;

        const operationPerformedClone = [...this.state.operationPerformed];
        operationPerformedClone[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].flag = true;
        if (this.props.updatePageList !== undefined) { this.props.updatePageList(pageListClone); }
        this.setState({
          pageList: pageListClone,
          operationPerformed: operationPerformedClone,
          dragMode: 'move',
          toggleCrop: !this.state.toggleCrop,
        });
      } else {
        this.setState({
          dragMode: 'crop',
          toggleCrop: !this.state.toggleCrop,
        });
      }
    }
  }

  toggleCanvas(pageList) {
    const currentImage = pageList[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent;
    const maskedCanvas = this.getFakeCanvas(currentImage, this.refs.cropper);
    const pageListClone = [...pageList];
    pageListClone[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent = maskedCanvas.toDataURL();

    if (this.props.updatePageList !== undefined) { this.props.updatePageList(pageListClone); }
    this.setState({
      pageList: pageListClone,
      dragMode: 'move',
    });
  }

  maskTheImage() {
    if (!this.state.toggleCrop) {
      if (this.state.toggleRedact) {
        const currentImage = this.state.pageList[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent;
        const maskedCanvas = this.getMaskedCanvas(currentImage, this.refs.cropper);
        const pageListClone = this.state.pageList;
        pageListClone[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent = maskedCanvas.toDataURL("image/jpeg");

        const operationPerformedClone = [...this.state.operationPerformed];
        operationPerformedClone[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].flag = true;
        if (this.props.updatePageList !== undefined) { this.props.updatePageList(pageListClone); }
        this.setState({
          dragMode: 'move',
          pageList: pageListClone,
          operationPerformed: operationPerformedClone,
          toggleRedact: !this.state.toggleRedact,
          toggleCrop: false,
          zoomText: '100%',
          currentZoomValue: 0.0,
        });
      } else {
        // Display crop region on the canvas.
        this.setState({
          dragMode: 'crop',
          toggleRedact: !this.state.toggleRedact,
          toggleCrop: false,
        });
      }
    }
  }

  undoEditing() {
    const pageListClone = [...this.state.pageList];
    const operationPerformedClone = [...this.state.operationPerformed];
    pageListClone[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent = this.state.orignalImages[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent;
    operationPerformedClone[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].flag = false;


    const rotateImageClone = [...this.state.rotateImage];
    rotateImageClone[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].rotateIndex = 0;
    if (this.props.updatePageList !== undefined) { this.props.updatePageList(pageListClone); }

    this.setState({
      pageList: pageListClone,
      dragMode: 'move',
      toggleCrop: false,
      toggleRedact: false,
      rotateImage: rotateImageClone,
      operationPerformed: operationPerformedClone,
      imageZoom: 0.3,
      zoomText: '100%',
      currentZoomValue: 0.0,
    });
  }

  filterOnChange(details) {
  }

  rotateToRight() {
    this.refs.cropper.rotate(90);
    const pageListClone = [...this.state.pageList];
    const rotatedImage = this.refs.cropper.getCroppedCanvas().toDataURL();
    pageListClone[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent = rotatedImage;
    const operationPerformedClone = [...this.state.operationPerformed];
    operationPerformedClone[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].flag = true;
    if (this.props.updatePageList !== undefined) { this.props.updatePageList(pageListClone); }
    this.setState({
      pageList: pageListClone,
      operationPerformed: operationPerformedClone,
      zoomText: '100%',
      currentZoomValue: 0.0,
    });
  }

  zoomIn() {
    if (this.state.currentZoomValue < 1) {
      this.refs.cropper.zoom(0.1);
      this.setState(
        {
          currentZoomValue: parseFloat((this.state.currentZoomValue + 0.1).toFixed(1)),
        },
        this.setZoomValue,
      );
    }
  }

  zoomOut() {
    if (this.state.currentZoomValue > -0.5) {
      this.refs.cropper.zoom(-0.1);
      this.setState(
        {
          currentZoomValue: parseFloat((this.state.currentZoomValue - 0.1).toFixed(1)),
        },
        this.setZoomValue,
      );
    }
  }

  setZoomValue() {
    this.state.zoomValues.map((item) => {
      if (this.state.currentZoomValue === item.value) {
        this.setState({
          zoomText: item.text,
        });
      }
    });
  }

  cropstart(event) {
  }

  getCroppedCanvas(options) {
  }


  updatePageSelectionIndex(canvasSelectedIndex) {
    if (canvasSelectedIndex < this.state.pageList.length && canvasSelectedIndex >= 0) {
      this.refs.cropper.zoom(0.0);
      this.setState({
        canvasSelectedIndex,
        currentZoomValue: 0.0,
        zoomText: '100%',
      });
    }
    if(this.props.updateCurrentSelectedImageIndex) {
      this.props.updateCurrentSelectedImageIndex(canvasSelectedIndex);
    }
  }

  checkDistance(x, y) {
    let prev;
    let dist = 9999;
    let i;
    const array = this.state.zoomValues;
    for (i = 0; i < array.length; i++) {
      if (array[i].value === x || array[i].value === y) {
        prev = i;
        break;
      }
    }
    for (i = prev + 1; i < array.length; i++) {
      if (array[i].value === x || array[i].value === y) {
        if (array[i].value != array[prev].value && (i - prev) < dist) {
          dist = i - prev;
          prev = i;
        } else {
          prev = i;
        }
      }
    }
    if (dist === 9999) { return 0; }
    if (x < 0 && x < y) { return -dist; }
    return dist;
  }

  onZoom(option) {
    const zoomOption = this.state.zoomValues.find((item) => item.value === option);
    let currentZoom = parseInt(this.state.currentZoomValue*10);
    let zoomVal = parseInt(zoomOption.value*10);
    while (zoomVal != currentZoom) {
      if (zoomVal > currentZoom) {
        this.refs.cropper.zoom(0.1);
        zoomVal--;
      } else if (zoomVal < currentZoom) {
        this.refs.cropper.zoom(-0.1);
        zoomVal++;
      }
    } 
    
    if (zoomOption) {
      this.setState({
        selectedZoom: zoomOption,
        currentZoomValue:zoomOption.value,
        zoomText: zoomOption.text,
      });
    }
  }


  render() {
    const canvasSelectedIndex = this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : (this.props.canvasSelectedIndex !== undefined && this.state.pageList.length - 1 < this.props.canvasSelectedIndex) ? 0 : this.props.canvasSelectedIndex;
    // This flag is used for disable delete button if image is already attached
    const isAttachedSelected = this.props.selectedPages !== undefined ? (this.props.selectedPages.findIndex((image) => {
      return image.isSelected && image.pageId == (this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex);
    })) : -1;
    const imagetoolKitStyle = this.props.isModal ? { bottom: 0 } : {};

    const currentIndex = canvasSelectedIndex;
    const totalPages = this.state.pageList.length;

    const isLeftDisabled = currentIndex <= 0;
    const isRightDisabled = currentIndex >= totalPages - 1;

    return (
      <div>
        {this.state.pageList.length > 0 && !this.props.imageContentsErr && (
          <div className="editor ">
            {<Cropper
              style={this.props.isModal ? { width: '100%', } : { width: '100%', height: '88vh', }}
              ref="cropper"
              src={this.state.pageList[canvasSelectedIndex].pageContent}
              guides={false}
              highlight
              rotatable
              autoCrop={false}
              dragMode={this.state.dragMode}
              center
              cropBoxMovable
              cropBoxResizable
              crop={this._crop.bind(this)}
              rotateTo={this.state.rotateImage[canvasSelectedIndex].rotateIndex}
              zoomOnWheel={false}
              toggleDragModeOnDblclick={false}
              getCroppedCanvas={this.getCroppedCanvas.bind(this)}
              cropstart={this.cropstart.bind(this)}
            />
            }

            {this.state.showImageToolkit && (
              <div className={this.props.isModal ? "image-float-toolkit" : "image-float-toolkitnomodal"} style={imagetoolKitStyle} >
                <ul className="image-ops">

                  <li className="tool-item">
                    <InformationBubble
                      id="1"
                      tooltipContent="Crop"
                    >
                      <div>
                        <Button
                          action={this.startCrop.bind(this)}
                          category="image-tool toggled"
                          icon={CropIcon}
                          iconDirection="left"
                        />
                      </div>
                    </InformationBubble>
                  </li>
                  <li className="tool-item">
                    <InformationBubble
                      id="2"
                      tooltipContent="Rotate"
                    >
                      <div>
                        <Button
                          action={this.rotateToRight.bind(this)}
                          category="image-tool toggled"
                          icon={ImageRotateIcon}
                          iconDirection="left"
                        />
                      </div>

                    </InformationBubble>
                  </li>
                  <li className="tool-item">
                    <InformationBubble
                      id="3"
                      tooltipContent="Sharpen"
                    >
                      <Button
                        action={this.sharpenTheImage.bind(this)}
                        category="image-tool toggled"
                        icon={ImageSharpenIcon}
                        iconDirection="left"
                      />
                    </InformationBubble>
                  </li>
                  <li className="tool-item">
                    <InformationBubble
                      id="4"
                      tooltipContent="Convert Grayscale"
                    >
                      <Button
                        action={this.makeGrayScale.bind(this)}
                        category="image-tool toggled"
                        icon={BlackAndWhiteIcon}
                        iconDirection="left"
                      />
                    </InformationBubble>
                  </li>

                  {
                    this.props.user && this.props.user.parsedPermissions && this.props.user.parsedPermissions.case &&
                    this.props.user.parsedPermissions.case.redactImage &&
                    (
                      <li className="tool-item">
                        <InformationBubble
                          id="5"
                          tooltipContent="Redact"
                        >
                          <Button
                            action={this.maskTheImage.bind(this)}
                            category="image-tool toggled"
                            icon={ImageRedactIcon}
                            iconDirection="left"
                          />
                        </InformationBubble>
                      </li>)
                  }

                  <li className="tool-item">
                    <InformationBubble
                      id="6"
                      tooltipContent="Duplicate"
                    >
                      <Button
                        action={this.duplicateImage.bind(this)}
                        category="image-tool toggled"
                        icon={ImageDuplicateIcon}
                        iconDirection="left"
                      />
                    </InformationBubble>
                  </li>

                  <li className="tool-item">
                    <InformationBubble
                      id="7"
                      tooltipContent="Delete"
                    >
                      <Button
                        action={this.deleteImage.bind(this)}
                        category="image-tool toggled"
                        icon={ImageDeleteIcon}
                        iconDirection="left"
                        disabled={this.state.pageList.length == 1 || isAttachedSelected !== -1}
                      />
                    </InformationBubble>
                  </li>
                </ul>
              </div>
            )
            }

            <div className={this.props.isModal ? "image-float-toolkit modal-kit-new" : "image-float-toolkitnomodal modal-kit-new"}>
              <div className={this.props.isModal ? "modal-kit-new" : this.props.addClass ? "modal-kit-w-50" : "modal-kit-w-100"}>
                <ul className="main-list">
                  <li style={{paddingRight:'unset'}}>
                    <Button
                      extraClass="pages-button"
                      action={this.handlePageSelector.bind(this)}
                      category="image-tool-pages"
                      iconDirection="left"
                    >
                      <PagesIcon />
                      <div className="pages-button-text-wrapper">
                        <span className="pages-button-text-wrapper-lable">Page</span>
                        <span className="pages-button-text-wrapper-number">{canvasSelectedIndex + 1}</span>
                        <span className="pages-button-text-wrapper-lable">of</span>
                        <span className="pages-button-text-wrapper-number">{this.state.pageList.length}</span>
                      </div>
                    </Button>
                  </li>
                  <li
                      className={`page-nav ${isLeftDisabled ? 'arrow-disabled' : ''}`}
                      onClick={
                        isLeftDisabled
                          ? undefined
                          : this.props.updatePageSelectionIndex == undefined
                            ? () => this.updatePageSelectionIndex(currentIndex - 1)
                            : () => this.props.updatePageSelectionIndex(currentIndex - 1)
                      }
                    >
                      <LeftArrowIcon disabled={isLeftDisabled} />
                    </li>
                  <li
                    className={`page-nav ${isRightDisabled ? 'arrow-disabled' : ''}`}
                    onClick={
                      isRightDisabled
                        ? undefined
                        : this.props.updatePageSelectionIndex == undefined
                          ? () => this.updatePageSelectionIndex(currentIndex + 1)
                          : () => this.props.updatePageSelectionIndex(currentIndex + 1)
                    }
                  >
                    <RightArrowIcon disabled={isRightDisabled} />
                  </li>
                  <li>
                    {
                      this.props.user && this.props.user.parsedPermissions && this.props.user.parsedPermissions.queue &&
                      this.props.user.parsedPermissions.queue.performImageOperations && this.props.documentTypeNames !=="Docs to the Issuer-no conversion" &&
                      (
                        <Button
                        action={!this.props.isReadOnly && this.showImageToolKit.bind(this)}
                        category="image-tool toggled"
                        icon={() => PencilIcon(this.state.pencilColor)}
                        iconDirection="left"
                        extraClass={this.props.isReadOnly ? "read-only-noedit" : ""}
                        />
                      )}
                  </li>

                  {Boolean(this.state.operationPerformed[canvasSelectedIndex].flag) && (
                    <li>
                      <Button
                        action={this.undoEditing.bind(this)}
                        extraClass="pages-button"
                        category="image-tool-undo"
                      >
                        <div className="pages-button-text-wrapper">
                          <span className="pages-button-undo-lable">Undo Editing</span>
                        </div>
                      </Button>
                    </li>
                  )
                  }
                </ul>

                <ul
                  className="zoom-options"
                  style={
                    this.props.addClass ?
                      this.props.zoomStyle ?
                        this.state.operationPerformed[canvasSelectedIndex].flag ?
                          { marginLeft: 440 } : this.props.zoomStyle
                        : { padding: 0, paddingRight: 77 }

                      : this.state.operationPerformed[canvasSelectedIndex].flag && this.props.isModal ?
                        { marginLeft: 520 } : this.props.isModal ?
                          { paddingLeft: 650 } : 
                            { paddingRight: 200 } 
                  }
                >
                  <li>
                    <Button
                      action={this.zoomIn.bind(this)}
                      category="image-tool toggled"
                      icon={ZoomInIcon}
                      iconDirection="left"
                    />
                  </li>

                  <li>
                    <Button
                      action={this.zoomOut.bind(this)}
                      category="image-tool toggled"
                      icon={ZoomOutIcon}
                      iconDirection="left"
                    />
                  </li>
                  <li>
                    <SelectInput
                      dataList={this.state.zoomValues}
                      promptText={`Zoom: ${this.state.zoomText}`}
                      handleSelection={this.onZoom}
                      wrapperClass="select-menu__form reports image-modal "
                      extraClass="option-box"
                      selectClass={{
                        color: '#007dc3',
                      }}
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )
        }
        {this.state.showPageSelector && (
          <PageSelector
            type={this.props.type}
            pageList={this.state.pageList}
            updatePageSelectionIndex={this.props.updatePageSelectionIndex == undefined ? this.updatePageSelectionIndex : this.props.updatePageSelectionIndex}
            canvasSelectedIndex={canvasSelectedIndex}
            updateParentSelectedPages={this.props.updateParentSelectedPages}
            imageCheckBoxRequired={this.props.imageCheckBoxRequired}
            summaryData={this.props.summaryData}
            selectedPages={this.props.selectedPages}
            selectAllFlag={this.props.selectAllFlag}
            isSelectedFlag={this.props.isSelectedFlag}
            pageselectormodal={this.props.pageselectormodal}
            isModal={this.props.isModal}
            updateCurrentSelectedImageIndex={this.props.updateCurrentSelectedImageIndex}
          />
        )
        }
        {
          this.props.imageContents.length == 0 && !this.props.imageContentsErr && <BVLoader20 />
        }
        {
          this.props.imageContentsErr && (
            <EmptyState
              translations={{ emptyStateHeading: counterpart('globalTranslate.queues.emptyStateHeading'), emptyStateDescription: counterpart('globalTranslate.queues.emptyStateDescription') }}
            />
          )
        }

        <div className="hiddenCanvas ">
          <img ref="image" alt="canvas selection" src={this.state.pageList.length > 0 && this.state.pageList[canvasSelectedIndex].pageContent} />
          <canvas ref="canvas" />
        </div>
      </div>
    );
  }
}

ImageToolkit.defaultProps = {
  title: 'Attach Document to Case',
  imageContents: [],
  imageContentsErr: false,
  addClass: false,
  transformedImageData: {},
  updateParentSelectedPages: () => { },
  isReadOnly: false,
};

ImageToolkit.propTypes = {
  title: PropTypes.string,
  updateParentSelectedPages: PropTypes.func,
  transformedImageData: PropTypes.object,
  imageContents: PropTypes.array,
  imageContentsErr: PropTypes.bool,
  updateFlag: PropTypes.bool,
  addClass: PropTypes.bool,
  isModal: PropTypes.bool,
  updateCurrentSelectedImageIndex: PropTypes.func,
  isReadOnly: PropTypes.bool,
};


function mapStateToProps(state) {
  return {
    transformedImageData: state.imageEditorData,
    user: state.auth.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    transformImage: (image, imageIndex, imageWidth, imageHeight, imageOperation) => dispatch(transformImage(image, imageIndex, imageWidth, imageHeight, imageOperation)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageToolkit);